import SmartToyIcon from '@mui/icons-material/SmartToy';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { AuthenticatedTemplate } from '@azure/msal-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMyProfileQuery } from '../../../../../services/ProfileService';
import { buildAgentsCatalogPath } from '../../../../agents/routes';
import { hasAgentsViewAccess } from '../../../../profile/utils/profileUtils';

function AgentsMenu() {
  const navigate = useNavigate();
  const { data: profile } = useGetMyProfileQuery();
  const company = profile?.organization ?? '';

  const navigateToAgents = () => {
    navigate(buildAgentsCatalogPath(company || undefined));
  };

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        {hasAgentsViewAccess(profile) && (
          <List component='nav' sx={{ border: 'black solid 1px' }}>
            <ListItemButton onClick={navigateToAgents} data-testid='agents-menu-button'>
              <ListItemIcon>
                <SmartToyIcon sx={{ color: 'white' }} />
              </ListItemIcon>
              <ListItemText primary='Agents' />
            </ListItemButton>
          </List>
        )}
      </AuthenticatedTemplate>
    </React.Fragment>
  );
}

export { AgentsMenu };
